// extracted by mini-css-extract-plugin
module.exports = {"buttonsList":"DocumentsType_buttonsList__57EHq","buttonItem":"DocumentsType_buttonItem__1H7Cb"};